/* LoTech Shop — small, dependency-free behaviors. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* Mobile menu */
    document.querySelectorAll('[data-lt-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Collection filters: submit on change */
    document.querySelectorAll('[data-lt-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="number"]')) return;
        form.submit();
      });
    });
    document.querySelectorAll('[data-lt-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.form || document.getElementById(el.getAttribute('form'));
        if (form) form.submit();
      });
    });
    document.querySelectorAll('[data-lt-filters-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Product page */
    document.querySelectorAll('[data-lt-product]').forEach(initProduct);
  });

  function initProduct(root) {
    var dataEl = root.querySelector('[data-lt-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var currency = root.getAttribute('data-currency') || 'USD';
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency });
    var money = function (cents) { return fmt.format(cents / 100); };

    var form = root.querySelector('[data-lt-form]');
    var idInput = root.querySelector('[data-lt-variant-id]');
    var qtyInput = root.querySelector('[data-lt-qty]');
    var mainImg = root.querySelector('[data-lt-main-img]');
    var submitBtns = root.querySelectorAll('[data-lt-submit]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-lt-option]'));

    function currentVariant() {
      if (!optionGroups.length) return product.variants[0];
      var selected = optionGroups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      }) || null;
    }

    function qty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      var lo = Math.max(1, parseInt(qtyInput && qtyInput.min, 10) || 1); return isNaN(n) || n < lo ? lo : n;
    }

    function render() {
      var v = currentVariant();
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-lt-option-value]');
        if (label && checked) label.textContent = checked.value;
      });
      var q = qty();
      var available = !!(v && v.available);
      if (v) {
        if (idInput) idInput.value = v.id;
        root.querySelectorAll('[data-lt-price]').forEach(function (el) { el.textContent = money(v.price); });
        root.querySelectorAll('[data-lt-variant-title]').forEach(function (el) { el.textContent = v.title === 'Default Title' ? '' : '· ' + v.title; });
        root.querySelectorAll('[data-lt-subtotal]').forEach(function (el) { el.textContent = money(v.price * q); });
        root.querySelectorAll('[data-lt-qtyline]').forEach(function (el) { el.textContent = q.toLocaleString('en-US') + ' × ' + money(v.price); });
        if (mainImg && v.featured_image && v.featured_image.src) {
          var src = v.featured_image.src;
          src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          mainImg.removeAttribute('srcset');
          mainImg.src = src;
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      submitBtns.forEach(function (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('[data-lt-submit-label]');
        if (label) label.textContent = !v ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
      });
      root.querySelectorAll('[data-lt-qchip]').forEach(function (chip) {
        chip.classList.toggle('is-on', parseInt(chip.getAttribute('data-lt-qchip'), 10) === q);
      });
    }

    optionGroups.forEach(function (group) { group.addEventListener('change', render); });
    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    }
    root.querySelectorAll('[data-lt-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-lt-step'), 10);
        var q = qty();
        var step = q > 100 || (q === 100 && dir > 0) ? 50 : (q > 10 || (q === 10 && dir > 0) ? 10 : 1);
        qtyInput.value = Math.max(parseInt(qtyInput.min, 10) || 1, q + dir * step);
        render();
      });
    });
    root.querySelectorAll('[data-lt-qchip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        qtyInput.value = chip.getAttribute('data-lt-qchip');
        render();
      });
    });

    /* Gallery thumbnails */
    root.querySelectorAll('[data-lt-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-lt-thumb');
        mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
        root.querySelectorAll('[data-lt-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
      });
    });

    /* Artwork file name */
    var file = root.querySelector('[data-lt-file]');
    if (file) {
      file.addEventListener('change', function () {
        var drop = file.closest('.lt-drop');
        var name = root.querySelector('[data-lt-file-name]');
        if (file.files && file.files[0]) {
          if (name) name.textContent = file.files[0].name;
          if (drop) drop.classList.add('has-file');
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        submitBtns.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });
      });
    }

    render();
  }
})();
